module.exports = __webpack_public_path__ + "img/logo_original.2f5e613b.svg";